var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.blok.table
    ? _c("table", { staticClass: "blok-table" }, [
        _vm.caption
          ? _c("caption", { domProps: { innerHTML: _vm._s(_vm.caption) } })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "thead",
          _vm._l(_vm.blok.table.thead, function (item, index) {
            return _c("th", { key: index }, [
              _vm._v("\n      " + _vm._s(item) + "\n    "),
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.blok.table.tbody, function (row, index) {
            return _c(
              "tr",
              { key: index },
              _vm._l(row, function (cell, index) {
                return _c("td", {
                  key: index,
                  domProps: { innerHTML: _vm._s(_vm.convertMarkdown(cell)) },
                })
              }),
              0
            )
          }),
          0
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }